'use client';

import AppLayout from '@/components/AppLayout';
import MessagesContent from './components/MessagesContent';

export default function MessagesPage() {
  return (
    <AppLayout>
      <MessagesContent />
    </AppLayout>
  );
}
